__webpack_require__.p = "/apple-pay/";